module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_6000.d57a1e44.png";